import * as React from "react";
import Input from "./Input";
import { addValidationRule } from "formsy-react";

interface Props {
  value: string;
  name: string;
  onValidPid?(pid: string): void;
  disabled?: boolean;
  required?: boolean;
}

addValidationRule("isEan", (values: any, value: string) => {
  if (!value) {
    return true;
  }
  if (!/^735999\d{12}$/.test(value)) {
    return false;
  }
  let checksum = 0;
  for (let i = 0; i < 17; i++) {
    const number = parseInt(value[i]);
    checksum += i % 2 ? number : number * 3;
  }

  checksum %= 10;
  checksum = checksum === 0 ? 0 : 10 - checksum;

  return parseInt(value[17]) == checksum;
});

export class EanInput extends React.Component<Props> {
  render() {
    return (
      <Input
        name={this.props.name}
        value={this.props.value}
        placeholder={"735 999 XXX XXX XXX XXX"}
        validations={{
          isEan: true,
        }}
        validationError="Ogiltigt EAN"
        onValidInput={this.props.onValidPid}
        type={"tel"}
        disabled={this.props.disabled}
        required={this.props.required}
      />
    );
  }
}
